import { createAsyncSelectors } from '../lib/selectors';
import { useAction } from './useAction';
import { useAsyncState } from './useAsyncState';
import { useAuthToken } from './useAuthToken';
import { useOnMount } from './useOnMount';
import { coreActions } from '@sonar-software/sonar-core';
const progressSelectors = createAsyncSelectors((state) => state.core.onboarding.progress.get);
export function useOnboardingProgress() {
    const { isLoggedIn } = useAuthToken();
    const { data, isReceived, isRequested } = useAsyncState(progressSelectors);
    const loadProgress = useAction(coreActions.requestGetCoreOnboardingProgress);
    const updateProgress = useAction(coreActions.updateOnboardingProgress);
    useOnMount(() => {
        if (isLoggedIn && !isReceived && !isRequested) {
            loadProgress();
        }
    });
    return {
        loading: !isReceived || !isLoggedIn,
        progress: data,
        updateProgress
    };
}
